import Region from "./Region";
import CNV_TYPES from "../browsers/Pulsar/constants/supportedCnv";
import { pathogenicityIndex as pathoInd } from "../browsers/Pulsar/constants/pathogenicity";
import { cnvTypeIndex } from "../browsers/Pulsar/constants/structuralVariantConstants";
import {
  DGV,
  dbNames,
  NCBI_DBVAR,
  CLINVAR_CNV,
} from "../browsers/Pulsar/constants/dbs";

function calc(v) {
  const { ClinVarRegionJson, GTExJsonData, JSON, DGVRegionJson } = v || {};
  const d = ClinVarRegionJson || GTExJsonData || JSON || DGVRegionJson || {};
  const pathoVal = d.acmg_class || d.pathogenicity || v.CLNSIG;
  return {
    pathoIndex: pathoInd[pathoVal] ?? pathoInd[""],
    type: v.type || v.SVTYPE || d.variant_class || d.sv_type || d.type,
    clinicalSig: d.clinical_significance || v.CLNSIG,
    length: v.length || parseInt(v.SVLEN, 10),
    data: d,
  };
}

class StructuralVariant {
  constructor(variant, chromosome, db) {
    const { type, pathoIndex, length, data, clinicalSig } = calc(variant);
    const { position } = variant;

    this.db = db;
    this.region = new Region(position, position + length, chromosome);
    this.id = `${this.region.g0}-${this.region.size}-${this.type}-${this.db.name}`;
    this.type = type;

    this.pathoIndex = pathoIndex;
    this.typeIndex = cnvTypeIndex[CNV_TYPES[this.type]] ?? cnvTypeIndex[""];

    this.regionId = variant.REGIONID;
    this.data = variant;
    this.regionData = data;
    this.clinicalSig = clinicalSig;
  }

  get dbLink() {
    if (this.db.name === dbNames[DGV]) {
      const { Accession: accession } = this.regionData;
      const { genomeId } = this.region.chromosome || {};
      if (!accession || !genomeId) return null;
      return `http://dgv.tcag.ca/gb2/gbrowse/dgv2_${genomeId}/?name=${accession};search=Search`;
    }

    if (this.db.name === dbNames[NCBI_DBVAR]) {
      if (!this.regionId) return null;
      return `https://www.ncbi.nlm.nih.gov/dbvar/variants/${this.regionId}/`;
    }

    if (this.db.name === dbNames[CLINVAR_CNV]) {
      const { variation_id: variationId } = this.regionData || {};
      if (!variationId) return null;
      return `https://www.ncbi.nlm.nih.gov/clinvar/variation/${variationId}`;
    }

    return null;
  }

  get spec() {
    const type = CNV_TYPES[this.type];
    if (!type) {
      return `${this.region.chromosome.name}:${this.region.x0}:L${this.region.size}`;
    }
    return `${this.region.chromosome.name}:${this.region.x0}:L${this.region.size}:${type}`;
  }

  get link() {
    const type = CNV_TYPES[this.type];
    if (!type) return null;
    return `/cnv/${this.region.chromosome.genomeId}/${this.region.chromosome.name}:${this.region.x0}:L${this.region.size}:${type}`;
  }
}

export default StructuralVariant;
